export default __webpack_public_path__ + "static/media/optimism_logo.c432ee1c.svg";